// extracted by mini-css-extract-plugin
module.exports = {"customOverlay":"Modal-modulecustomOverlay2j5","customModal":"Modal-modulecustomModalQBi"};